import { mutations } from "@shared/template/StoreTemplates/FilterStoreTemplate"

export default {
  ...mutations
}
